
import {
  IconEcologicDark,
  IconFastDark,
  IconGoodPricesDark,
  IconSecuredDark,
  RevButtonDefault,
  RevLink,
  RevRating,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { ROUTES } from '@router'

import translations from './Presentation.translations'

export default {
  components: {
    RevButtonDefault,
    RevLink,
    RevRating,
  },
  computed: {
    ...mapGetters({ globalRate: 'rates/backmarket/get' }),
    translations: () => translations,
    ROUTES: () => ROUTES,
    shouldDisplayRates() {
      return (
        this.globalRate.reviewsCount >= 10 && this.globalRate.averageRate >= 4
      )
    },
    hasAverageRate() {
      return (
        this.globalRate.averageRate !== undefined &&
        this.globalRate.averageRate !== null
      )
    },
    presentationList() {
      return [
        {
          icon: IconFastDark,
          title: this.$t(translations.block1Title),
          text: this.$t(translations.block1Text),
        },
        {
          icon: IconGoodPricesDark,
          title: this.$t(translations.block2Title),
          text: this.$t(translations.block2Text),
        },
        {
          icon: IconSecuredDark,
          title: this.$t(translations.block3Title),
          text: this.$t(translations.block3Text),
        },
        {
          icon: IconEcologicDark,
          title: this.$t(translations.block4Title),
          text: this.$t(translations.block4Text),
        },
      ]
    },
  },
}
